module.exports = __webpack_public_path__ + "static/media/primary-logo.de3064d6.png";